module.exports = __webpack_public_path__ + "static/img/2.9785d7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Infidelidad-Riesgos-Financieros/2.png
// module id = 13mo
// module chunks = 0